import {
  CreateScheduledQueryBody,
  ListScheduledQueriesParams,
  ScheduledQuery,
  scheduledQueriesV2,
  scheduledQueryConversations,
  UpdateScheduledQueryBody,
} from '@api';
import { generatePath } from '@helpers';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const listScheduledQueries = (
  params: ListScheduledQueriesParams = {}
) => {
  const path = generatePath({
    basePath: scheduledQueriesV2.list.path,
    params: {
      ...(params.status && { status: params.status }),
      ...(params.page && { page: params.page }),
      ...(params.page_size && { page_size: params.page_size }),
    },
  });

  return wretchRequest(path, { schema: scheduledQueriesV2.list.schema });
};

export const getScheduledQuery = (id: string) =>
  wretchRequest(scheduledQueriesV2.get.path(id), {
    schema: scheduledQueriesV2.get.schema,
  });

export const listScheduledQueryConversations = (
  id: string,
  params: { page?: number; page_size?: number } = {}
) => {
  // Endpoint #9 lives in conversation service, not conversation-scheduler
  const path = generatePath({
    basePath: scheduledQueryConversations.list.path(id),
    params: {
      ...(params.page && { page: params.page }),
      ...(params.page_size && { page_size: params.page_size }),
    },
  });

  return wretchRequest(path, {
    schema: scheduledQueryConversations.list.schema,
  });
};

export const createScheduledQuery = (
  body: CreateScheduledQueryBody
): Promise<ScheduledQuery> =>
  wretchRequest(scheduledQueriesV2.create.path, {
    method: 'post',
    body,
    schema: scheduledQueriesV2.create.schema,
  });

export const updateScheduledQuery = (
  id: string,
  body: UpdateScheduledQueryBody
) =>
  wretchRequest(scheduledQueriesV2.update.path(id), {
    method: 'put',
    body,
  });

export const deleteScheduledQuery = (id: string) =>
  wretchRequest(scheduledQueriesV2.delete.path(id), {
    method: 'delete',
  });

export const suspendScheduledQuery = (id: string) =>
  wretchRequest(scheduledQueriesV2.suspend.path(id), {
    method: 'post',
    body: {},
  });

export const resumeScheduledQuery = (id: string) =>
  wretchRequest(scheduledQueriesV2.resume.path(id), {
    method: 'post',
    body: {},
  });

export const runScheduledQueryNow = (id: string) =>
  wretchRequest(scheduledQueriesV2.runNow.path(id), {
    method: 'post',
    body: {},
    schema: scheduledQueriesV2.runNow.schema,
  });
